import { render, staticRenderFns } from "./tem_sidebar.vue?vue&type=template&id=7c2858b8&scoped=true&"
import script from "./tem_sidebar.vue?vue&type=script&lang=js&"
export * from "./tem_sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2858b8",
  null
  
)

export default component.exports